import React from 'react';
import { flex, getCssVarColorWithOpacity } from '@fabric-ui/theme';
import { ellipsis } from '@fabric-ui/utils';
import { Box, type SxProps, type Theme } from '@mui/material';
import { AvAvatar } from '../AvAvatar';
import { AvTooltip } from '../AvTooltip';
import { LogoBase } from './LogoBase';

export interface ItemWithLogoBaseProps {
  displayName: string;
  logoSrc: string;
  logoWidth?: number;
  textStyle?: SxProps<Theme>;
  hideText?: boolean;
  tooltip?: boolean;
  isAvatar?: boolean;
  vertical?: boolean;
  avatarSize?: number;
  transparent?: boolean;
  logoAlt?: string;
}

export function ItemWithLogoBase({
  displayName,
  logoSrc,
  logoWidth = 24,
  textStyle = {} as SxProps<Theme>,
  hideText = false,
  tooltip = true,
  isAvatar = false,
  vertical = false,
  avatarSize,
  transparent,
  logoAlt,
}: ItemWithLogoBaseProps) {
  const content = (
    <Box
      sx={{
        ...(vertical ? flex.colCenter : flex.row),
        gap: vertical ? '2px' : 1,
        lineHeight: `${logoWidth}px`,
        ...ellipsis,
        flexShrink: isAvatar ? 0 : undefined,
      }}>
      {isAvatar ? (
        <LogoBase src={logoSrc} width={logoWidth} transparent={transparent ?? true}>
          <AvAvatar displayName={displayName} size={avatarSize} />
        </LogoBase>
      ) : (
        <LogoBase src={logoSrc} width={logoWidth} transparent={transparent} alt={logoAlt ?? displayName} />
      )}
      {!hideText && (
        <Box component="span" sx={textStyle}>
          <AvTooltip>{displayName}</AvTooltip>
        </Box>
      )}
    </Box>
  );
  return tooltip && hideText ? <AvTooltip title={displayName}>{content}</AvTooltip> : content;
}

export const logoStyle = (size: number) => ({
  width: size,
  height: size,
  color: 'var(--color-content-immutable-lightGrey)',
  backgroundColor: getCssVarColorWithOpacity('var(--color-content-immutable-lightGrey)', 0.28, '#ffffff'),
  borderRadius: '50%',
});
